import { Formik } from "formik";
import { useCallback, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { Form, Button, Typography, Input, Upload, message } from "antd";
import { UploadFile } from "antd/lib/upload/interface";

import {
  userRoles,
} from "components/tab-content/users-content/__mock__";
import { dialCodePrefix, fileToByteArray } from "utils/helpers";
import { FormItem, SelectSearch } from "components";
import { USER_FORMIK } from "utils/formik-data";
import { UserValues } from "types/formik";
import { SelectType } from "types";
import { uploadIcon } from "svgs";
import { useSelector } from "react-redux";
import { AppState } from "../../store";
import { RcFile } from "antd/lib/upload";

const { Title, Text } = Typography;

interface ComponentProps {
  initialValues: UserValues;
  vehiclesOptions: SelectType;
  organizationOptions: SelectType;
  setValues: (values: UserValues) => void;
  userType: any;
  onCancel?: React.MouseEventHandler<HTMLElement>;
}

export default function AddUserForm(props: ComponentProps) {
  const {
    initialValues,
    vehiclesOptions,
    organizationOptions,
    onCancel,
    setValues,
    userType,
  } = props;
  const [rider, setRider] = useState(0);
  const [msg, setMsg] = useState("");
  const [orgshow, setOrgShow] = useState(1);

  const onSubmit = useCallback(
    (values: UserValues) => {
      setValues(values);
    },
    [setValues]
  );

  let userRolesByCurrentUser = userRoles;
  if (userType == 2) {
    userRolesByCurrentUser = userRoles.filter(
      (role) => role.value != "1" && role.value != "3"
    );
  } else if (userType == 3) {
    userRolesByCurrentUser = userRoles.filter(
      (role) =>
        role.value != "1" &&
        role.value != "5" &&
        role.value != "2" &&
        role.value != "6"
    );
  } else if (userType == 5) {
    // Client Admin: prevent adding Customer Manager (7) and Production Manager (8)
    userRolesByCurrentUser = userRoles.filter(
      (role) =>
        role.value != "1" &&
        role.value != "5" &&
        role.value != "2" &&
        role.value != "6" &&
        role.value != "7" &&
        role.value != "8"
    );
  } else if (userType == 7) {
    userRolesByCurrentUser = userRoles.filter(
        (role) =>
            role.value != "1" &&
            role.value != "3" &&
            role.value != "2" &&
            role.value != "6" &&
            role.value != "7"
    );
  } else if (userType == 8) {
    userRolesByCurrentUser = userRoles.filter(
      (role) =>
        role.value != "1" &&
        role.value != "3" &&
        role.value != "2" &&
        role.value != "4" &&
        role.value != "5" &&
        role.value != "7" &&
        role.value != "8"

    );
  }

  const customRequest = ({
    onSuccess,
    onError,
    file,
  }: {
    onSuccess: (response: object, file: RcFile) => void;
    onError: (error: Error, response?: any, file?: RcFile | undefined) => void;
    file: RcFile;
  }) => {
    setTimeout(() => {
      if (file.size > 500 * 1024) {
        onError(new Error("File size must be less then 50Kb"));
        message.error("File size must be less then 50Kb");
        setMsg("File size must be less then 500Kb");
        return;
      } else if (!(file.type in ["image/png", "application/pdf"])) {
        onError(new Error("File must be png or pdf"));
        message.error("You can only upload PNG and PDF files!");
        setMsg("You can only upload PNG and PDF files!");
        return;
      }
      setMsg("");
    }, 1000);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={USER_FORMIK.validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        setFieldValue,
        dirty,
        isValid,
        handleSubmit,
        handleChange,
        values,
        errors,
      }) => (
        <div className="form-container">
          <div className="form-header">
            <Title level={5} className="form-title">
              Add a User
            </Title>
            <Text className="description" type="secondary">
              Please provide the authentic profile details mentioned below to
              add a user
            </Text>
          </div>

          <Form className="--add-users-form" onFinish={handleSubmit}>
            <section className="form-fields-section">
              {/* Phone Number */}
              <div className="form-field-wrapper">
                <FormItem label="Phone Number" error={errors.phone_no} required>
                  <PhoneInput
                    country={
                      values.dial_code === "971"
                        ? "ae"
                        : values.dial_code === "92"
                        ? "pk"
                        : "pk"
                    }
                    inputProps={{
                      autoFocus: true,
                      required: true,
                      name: "phone_no",
                    }}
                    inputClass="login-phone-input --user"
                    buttonClass="user-flag"
                    value={values.phone_no}
                    placeholder={
                      values.dial_code === "971"
                        ? "5x xxx xxxx"
                        : values.dial_code === "92"
                        ? "3xx xxxxxxx"
                        : "Enter phone number"
                    }
                    onChange={(
                      val,
                      data: { dialCode: string; countryCode: string }
                    ) => {
                      setFieldValue("dial_code", data.dialCode);
                      setFieldValue("phone_no", val);
                    }}
                  />
                </FormItem>
              </div>

              {/* Email Address */}
              <div className="form-field-wrapper">
                <FormItem label="Email Address" error={errors.email} required>
                  <Input
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    placeholder="user@email.com"
                  />
                </FormItem>
              </div>

              {/* Full Name */}
              <div className="form-field-wrapper">
                <FormItem label="Full Name" error={errors.full_name} required>
                  <Input
                    name="full_name"
                    value={values.full_name}
                    onChange={handleChange}
                    placeholder="Name"
                  />
                </FormItem>
              </div>

              {/* CNIC */}
              <div className="form-field-wrapper">
                <FormItem label="CNIC" error={errors.national_id} required>
                  <Input
                    name="national_id"
                    value={values.national_id}
                    onChange={handleChange}
                    placeholder="XXXXX-XXXXXXX-X"
                  />
                </FormItem>
              </div>

              {/* Role */}
              <div className="form-field-wrapper">
                <FormItem label="Role" error={errors.role} required>
                  <SelectSearch
                    value={values.role}
                    items={userRolesByCurrentUser}
                    setFieldValue={setFieldValue}
                    fieldName="role"
                    placeholder="Select Role"
                    onChangeProp={(el) => {
                      if (!el) {
                        setOrgShow(0);
                      } else if (el == "3") {
                        setRider(1);
                        setOrgShow(0);
                      } else if (el == "5") {
                        setRider(0);
                        setOrgShow(1);
                      } else {
                        setRider(0);
                        setOrgShow(0);
                      }
                    }}
                  />
                </FormItem>
              </div>

              {/* Assigned Vehicle - Conditional */}
              {rider > 0 && (
                <div className="form-field-wrapper">
                  <FormItem label="Assigned Vehicle" error={errors.vehicle}>
                    <SelectSearch
                      isMultiple
                      value={values.vehicle || ""}
                      items={vehiclesOptions}
                      setFieldValue={setFieldValue}
                      fieldName="vehicle"
                      placeholder="Select"
                      onChangeProp={(value) => {
                        setFieldValue("vehicle", value);
                      }}
                    />
                  </FormItem>
                </div>
              )}

              {/* Driver's License Number - Conditional */}
              {rider > 0 && (
                <div className="form-field-wrapper">
                  <FormItem
                    label="Driver's License Number"
                    error={errors.licence_no}
                  >
                    <Input
                      name="licence_no"
                      value={values.licence_no}
                      onChange={handleChange}
                      placeholder="000000"
                    />
                  </FormItem>
                </div>
              )}

              {/* Document Upload - Conditional */}
              {rider > 0 && (
                <div className="form-field-wrapper form-field-full-width">
                  <FormItem
                    label="CNIC/Driver's License"
                    error={errors.document_file}
                    verticalAlign="flex-start"
                  >
                    <Upload.Dragger
                      name="document_file"
                      multiple={false}
                      customRequest={customRequest}
                      fileList={values.fileList}
                      accept={"png"}
                      onChange={({ fileList }) => {
                        const totalFiles = fileList.length;
                        if (totalFiles > 1) {
                          setFieldValue("fileList", [fileList[totalFiles - 1]]);
                        } else {
                          setFieldValue("fileList", fileList);
                        }
                      }}
                      beforeUpload={async (file) => {
                        if (
                          file.size > 10 * 1024 ||
                          !(file.type in ["image/png", "application/pdf"])
                        ) {
                          setFieldValue("fileList", []);
                          values.fileList = [];
                          isValid = false;
                          return;
                        }
                        const unit8Arr = await fileToByteArray(file);
                        setFieldValue("document_file", unit8Arr);
                        setFieldValue("document_file_raw", file);
                      }}
                    >
                      <div className="upload-content">
                        <span className="upload-icon">{uploadIcon}</span>
                        <p className="ant-upload-text">
                          <span className="upload-hint">
                            Support for PNG and PDF files, up to 512 KB
                          </span>
                          <br />
                          <span className="upload-action">
                            Drag the document here or
                            <span className="secondary-color"> browse</span> from
                            system
                          </span>
                        </p>
                      </div>
                    </Upload.Dragger>
                    {msg && <p className="ant-upload text-danger">{msg}</p>}
                  </FormItem>
                </div>
              )}

              {/* Client/Organization - Conditional */}
              {values.role === "5" && (
                <div className="form-field-wrapper">
                  <FormItem
                    label="Client"
                    error={errors.organization_id}
                    required
                  >
                    <SelectSearch
                      value={values.organization_id || ""}
                      items={organizationOptions}
                      setFieldValue={setFieldValue}
                      fieldName="organization_id"
                      placeholder="Select"
                      onChangeProp={(value) =>
                        setFieldValue("organization_id", value)
                      }
                    />
                  </FormItem>
                </div>
              )}
            </section>

            {/* Action Buttons */}
            <div className="action-btn-container">
              <Button className="cancel-btn" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                disabled={(!isValid && dirty) || values.phone_no === ""}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
}